<template>
  <v-hover v-slot:default="{hover}">
    <v-img v-if="logo.linkUrl"
           :src="require(`../assets/brand_logos/${logo.img_path}`)"
           :alt="logo.title"
           aspect-ratio="1"
           max-width="144"
           style="cursor: pointer; margin: 0 auto;"
           @click="logoClick(logo.linkUrl)"/>
    <v-img v-else
           :src="require(`../assets/brand_logos/${logo.img_path}`)"
           :alt="logo.title"
           style="margin: 0 auto;"
           aspect-ratio="1"
           max-width="144"/>
    <!--v-card flat class="mx-auto" max-width="320" height="320" :elevation="hover ? 2 : 0">
    </v-card-->
  </v-hover>
</template>

<script>
export default {
  name: 'logo',
  props: {
    logo: Object,
  },
  data() {
    return {
      //
    };
  },
  methods: {
    logoClick(url) {
      window.open(url, '_blank');
    },
  },
};
</script>

<style scoped>

</style>
